import React, { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import LoginButton from "../LoginButton/LoginButton";

import { GetCurrentUser } from "../../utilities/functions";
import { UserPermissions, UserStatus } from "../../utilities/enumerators";
import L33tComponent from "./components/L33tComponent";
import RouteItemHander from "./components/RouteItemHander";
import MenuBarComponent from "./components/MenuBarComponent";
import { INavigationBar } from "./types";
import NotificationBarComponent from "./components/NotificationBarComponent";

import "./NavigationBarStyles.css";
export const NavigationBar: React.FC<INavigationBar> = (props) => {
  let margin = "width-80";

  const { user, isAuthenticated } = useAuth0();
  const userLoggedIn = GetCurrentUser();

  useEffect(() => {
    if (
      !sessionStorage.getItem("auth0ProfilePicture") &&
      user?.email_verified &&
      userLoggedIn
    ) {
      sessionStorage.setItem("auth0ProfilePicture", user?.picture!);
    }
  }, []);

  return (
    <>
    <div className="min-height-45px">

    </div>
    <div className='bg-light-blue py-1 m-0 header'>
      <div className={margin}>
        <div className=''>
          <div className='d-flex justify-content-between'>
            <L33tComponent isBlock={true} />
            <div>
              <nav className='navbar navbar-expand-lg navbar-dark p-0 m-0'>
                <div className='container-fluid m-0 p-0'>
                  {userLoggedIn?.status === UserStatus.ACTIVE && (
                    <div className='m-0 p-0'>
                      <button
                        className='navbar-toggler toggler p-0 m-0 mt-2'
                        type='button'
                        data-bs-toggle='collapse'
                        data-bs-target='#navbarNavDropdown'
                        aria-controls='navbarNavDropdown'
                        aria-expanded='false'
                        aria-label='Toggle navigation'
                      >
                        <span className='navbar-toggler-icon p-0 m-0'></span>
                      </button>
                      <div
                        className='collapse navbar-collapse justify-content-end align-items-center m-0 p-0 max-h'
                        id='navbarNavDropdown'
                      >
                        <ul className='navbar-nav m-0 p-0'>
                          <RouteItemHander toPage='/home' title='Quotes' />
                          <RouteItemHander toPage='/projects' title='Projects' />
                          {userLoggedIn.userPermissionId !==
                            UserPermissions.TEAM_MEMBER &&
                            userLoggedIn.userPermissionId !==
                              UserPermissions.READ_ONLY && (
                              <RouteItemHander
                                toPage='/panels'
                                title='Panels'
                              />
                            )}
                          {userLoggedIn.userPermissionId !==
                            UserPermissions.TEAM_MEMBER &&
                            userLoggedIn.userPermissionId !==
                              UserPermissions.READ_ONLY && (
                              <RouteItemHander
                                toPage='/organisations'
                                title='Organisations'
                              />
                            )}
                         

                          {userLoggedIn.userPermissionId !==
                            UserPermissions.TEAM_MEMBER &&
                            userLoggedIn.userPermissionId !==
                              UserPermissions.READ_ONLY && (
                              <RouteItemHander toPage='/users' title='Users' />
                            )}
                          {userLoggedIn.userPermissionId !==
                            UserPermissions.TEAM_MEMBER &&
                            userLoggedIn.userPermissionId !==
                              UserPermissions.READ_ONLY && (
                              <RouteItemHander
                                toPage='/quoteSettings'
                                title='Settings'
                              />
                            )}

                          <NotificationBarComponent />
                          <MenuBarComponent picture={user?.picture}
                          // user={user?}
                          />
                        </ul>
                      </div>
                    </div>
                  )}

                  {userLoggedIn?.status !== UserStatus.ACTIVE && (
                    <div className='box-3 '>
                      <div className='pt-0 pe-2'>
                        {!isAuthenticated && <LoginButton />}
                      </div>
                      <div className='pt-0 pe-2'>
                        {isAuthenticated && <LoginButton />}
                      </div>
                    </div>
                  )}
                </div>
              </nav>
            </div>
            <L33tComponent />
          </div>
        </div>
      </div>
    </div>
    </>
  );
};
